import "jquery-bar-rating";

const initStarRating = () => {
    $('.star-liga').barrating({
        theme: 'css-stars'
      });
};

export { initStarRating };